import { render } from "./FavoriteSpotSuggest.vue?vue&type=template&id=0b731a0f"
import script from "./FavoriteSpotSuggest.vue?vue&type=script&lang=js"
export * from "./FavoriteSpotSuggest.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__